import { createContext, useContext, useEffect, useReducer } from "react";
import reducer from "./reducer";
import {
  GET_CURRENT_USER_BEGIN,
  GET_CURRENT_USER_SUCCESS,
  SET_OFFERING_MODEL,
  SET_OFFERING_CLASS,
  SET_ASSET_CLASS_SEARCH,
} from "./actions";
import { createClient } from "@/utils/supabase/client";

export const initialState = {
  offeringModel: "",
  offeringClass: "",
  isSaving: false,
  userLoading: false,
  user: null,
  assetClassSearch: null,
};

const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const supabase = createClient();

  const getCurrentUser = async () => {
    dispatch({ type: GET_CURRENT_USER_BEGIN });
    const {
      data: { user: userData },
      error: userError,
    } = await supabase.auth.getUser();

    if (userError || !userData) {
      console.log("error fetching user", userError);
    }

    dispatch({
      type: GET_CURRENT_USER_SUCCESS,
      payload: {
        user: userData,
      },
    });
  };

  useEffect(() => {
    getCurrentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setOfferingModel = (offeringModel) => {
    dispatch({
      type: SET_OFFERING_MODEL,
      payload: { offeringModel },
    });
  };

  const setOfferingClass = (offeringClass) => {
    dispatch({
      type: SET_OFFERING_CLASS,
      payload: { offeringClass },
    });
  };

  const setAssetClassSearch = (assetClassSearch) => {
    dispatch({
      type: SET_ASSET_CLASS_SEARCH,
      payload: { assetClassSearch },
    });
  };

  return (
    <AppContext.Provider
      value={{
        ...state,
        setOfferingModel,
        setOfferingClass,
        setAssetClassSearch,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

//custom hook to use the app context
export const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider };
